module.exports = __webpack_public_path__ + "img/vps-platform.0b08a39.png";